import "./_style.scss";
import { useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { headTitleList, listData, schema } from "./parts";
import { Box } from "@mui/material";
import TkDataTable from "../../components/molecules/TkDataTable";
import { GlobalContext } from "../../context/globalContext";
import { BusinessContext } from "../../context/businessContext";
import { AccountStatus } from "../../assets/data/Constants";
import { httpAPI_ACC003 } from "./api/request";
import TkSearchForm from "../../components/molecules/TkSearchForm";
import { Link } from "@mui/material";
import { TkGetCode } from "../../utils/TkGetCode";
import _ from "lodash";

/**
 * SCRW100001 契約者アカウント一覧
 * @return SCRW100001 契約者アカウント一覧
 */
const SCRW100001 = () => {
  const navigate = useNavigate();
  const { state, setState } = useContext(GlobalContext);
  const { state: businessState, setState: setBusinessState } =
    useContext(BusinessContext);
  const context = businessState.job_100;
  const [stateSearchList, setStateSearchList] = useState<any>([]);
  const stateList = useRef(_.cloneDeep(listData));
  const [accountsCorpUserListTable, setAccountsCorpUserListTable] = useState<
    any[]
  >([]);

  useEffect(() => {
    let resArr = stateList.current;
    if (context) {
      for (let i in context) {
        let targetObj = resArr.find((item: any) => item.keyword === i)!;

        targetObj &&
          (targetObj.wantToSetValue = context[i as keyof typeof context]);
      }

      searchList(context);
    }
    setStateSearchList([...resArr]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //「ログインID リンク 押下」処理用イベント
  const handleClick = (userId: string) => {
    navigate("/SCRW100002", { state: { userId: userId } });
  };

  const searchList = async (data: any) => {
    try {
      const res = await httpAPI_ACC003({ ...data });

      setAccountsCorpUserListTable([]);
      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });

        const bodyList = res.corpUserList?.map((item) => [
          {
            children: (item.contractorNo ?? "") + ":" + (item.corpName ?? ""),
            forSort: item.contractorNo,
          },
          { children: item.name, forSort: item.name },
          {
            children: item.kbn === "1" && "〇",
            forSort: item.kbn,
            align: "center",
          },
          {
            children: (
              <Link onClick={() => handleClick(item.userId!)}>
                {item.userId}
              </Link>
            ),
            forSort: item.userId,
          },
          {
            children: TkGetCode(AccountStatus, item.status),
            forSort: item.status,
          },
        ]);

        setAccountsCorpUserListTable(bodyList ?? []);

        setBusinessState({ job_100: { ...data } });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  return (
    <Box data-testid="SCRW100001PageForTest" className="tkSCRW100001">
      <Box className="tkSerchItems">
        <TkSearchForm
          onSearch={searchList}
          listData={stateSearchList}
          ruleSchema={schema}
        />
      </Box>

      <TkDataTable
        headList={headTitleList}
        bodyList={accountsCorpUserListTable}
        count={accountsCorpUserListTable.length}
        defaultRowsPerPage={10}
        pagin
      />
    </Box>
  );
};

export default SCRW100001;
